import { useEffect, useState } from 'react';

/**
 * Desktop-wide layout: the conversation list stays on the left and whatever
 * you open (a thread, a letter, a friend's summary, your profile) shows in a
 * side panel instead of replacing the list.
 */
export const WIDE_QUERY = '(min-width: 1024px)';
/**
 * The side panel splits a thread in two — letters on the left, the
 * relationship's details (tier, notes, your letters together) on the right.
 * Same breakpoint as the wide layout, so the details are never a tap away on a
 * desktop; below 1200px the list and the details column narrow to make room.
 */
export const WIDEST_QUERY = WIDE_QUERY;

export function useIsWide(query: string = WIDE_QUERY): boolean {
  const [wide, setWide] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    setWide(mq.matches);
    const on = () => setWide(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return wide;
}
